import { conversations } from '@api';
import { apiFetch } from '@terminal/utils/api-fetch/apiFetch';

export const updateSettings = (instructions: string) =>
  apiFetch(conversations.putSettings.path, {
    method: 'put',
    body: {
      prompt: instructions,
    },
  });

export const getSettings = () =>
  apiFetch(conversations.getSettings.path, {
    schema: conversations.getSettings.schema,
  });
